import { instance } from "apis/interceptor";
import { ResponseType } from "apis/meetings/meeting-reservation";

//INFO: 개인 캘린더 연동
export const connectPersonalCalendar = async (
  calendarId: string,
  calendarName: string,
  googleRefreshToken: string
): Promise<ResponseType<boolean>> => {
  try {
    const result = await instance.post(`/personal-calendar/google`, {
      calendarId,
      calendarName,
      googleRefreshToken,
    });
    return { success: result.data.result };
  } catch (e) {
    console.error(e);
    return { success: false, message: "개인 캘린더 연동에 실패했습니다." };
  }
};

//INFO: 개인 캘린더 연동 해제
export const disconnectPersonalCalendar = async (): Promise<ResponseType<boolean>> => {
  try {
    const result = await instance.delete(`/personal-calendar/google`);
    return { success: result.data.result };
  } catch (e) {
    console.error(e);
    return { success: false, message: "개인 캘린더 연동 해제에 실패했습니다." };
  }
};

//INFO: 개인 캘린더 연동 여부 확인
export const getPersonalCalendarConnection = async (): Promise<ResponseType<boolean>> => {
  try {
    const result = await instance.get(`/personal-calendar/google`);
    if (result.data.id) {
      return { success: true };
    } else
      return {
        success: false,
      };
  } catch (e) {
    console.error(e);
    return { success: false, message: "개인 캘린더 연동 여부 확인에 실패했습니다." };
  }
};
